import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'parseUtcToLocal',
  standalone: true,
})
export class ParseUtcToLocalPipe implements PipeTransform {
  transform(value: string | Date | null | undefined): Date | null {
    if (!value) return null;

    return DateTime.fromISO(String(value), { zone: 'utc' })
      .toLocal()
      .toJSDate();
  }
}
